module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/offerta/offerta.component.scss
// module id = ./src/app/offerta/offerta.component.scss
// module chunks = main